import React, { useState } from "react";
import QRGenerateButton from "./QRGenerateButton";
import upiImage from "../images/upi-services.png";

function UpiQR() {
  const [input, setInput] = useState("");
  const [showQR, setShowQR] = useState(false);
  const [formError, setFormError] = useState(false);
  const [vpaName, setVpaName] = useState("");
  const [vpaFullName, setVpaFullName] = useState("");

  function createUPI() {
    if (vpaName !== "" && vpaFullName !== "") {
      var QRUpi =
        "upi://pay?pa=" +
        vpaName +
        "&pn=" +
        encodeURIComponent(vpaFullName) +
        "&cu=INR";
      setInput(QRUpi);
      showQRCode();
      setFormError(false);
      setShowQR(true);
    } else {
      setShowQR(false);
      setFormError(true);
    }
  }

  function showQRCode() {
    document.getElementById("qrwrap").scrollIntoView({
      behavior: "smooth",
    });
  }
  return (
    <>
      <div className="qr-form">
        <h3>UPI QR Code</h3>
        <p>
          <img width="350" src={upiImage} alt="upi service" />
        </p>
        <p>
          Tired of giving phone number or UPI id to accept payments from your
          customers? Create a QR code and leave out the hassles. It's safe &amp;
          secure.
        </p>
        <p>
          You can create QR Code for <strong>any</strong> UPI payment providers
          / facilitators including PayTM, PhonePe, GPay, AmazonPay, and all
          other UPI service provided by leading banks.
        </p>
        <input
          type="text"
          value={vpaFullName}
          onInput={(e) => setVpaFullName(e.target.value)}
          name="qrcode_vpfullname"
          id="qr_vpafullname"
          placeholder="Enter your full name"
        />
        <input
          type="text"
          value={vpaName}
          onInput={(e) => setVpaName(e.target.value)}
          name="qrcode_vpaname"
          id="qr_vpaname"
          placeholder="Enter UPI ID (yourname@bank)"
        />
        <p>Do double-check the details are correct, money matters!</p>
        {formError && (
          <div className="errorMessage">Error: Field cannot be blank!</div>
        )}
        <button
          type="button"
          className="contrast"
          onClick={() => {
            createUPI();
          }}
        >
          Generate QR
        </button>
      </div>
      <QRGenerateButton
        QRType="upi"
        QRValue={input}
        showQR={showQR}
        setInput={setInput}
        setShowQR={setShowQR}
      />
    </>
  );
}

export default UpiQR;
